module.exports = "<ngx-ui-loader></ngx-ui-loader>\n<ion-app>\n  <ion-router-outlet [swipeGesture]=\"false\"></ion-router-outlet>\n</ion-app>\n"